import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { PickupService } from '@checkout-v2/feature';
import { EnvironmentService } from '@core/feature';
import { TodayTomorrowDatePipe } from '@sdvor/shared/ui';
import { ShopWorkingTimeService } from '@shop/feature';
import { ShopListMobileComponent } from '@shop/ui';
import { CxDatePipe } from '@spartacus/core';
import { ModalService } from '@spartacus/storefront';
import { GeocodeService } from '@yandex-maps/feature';

@Component({
  selector: 'sd-pickup-shop-list-mobile',
  templateUrl: './pickup-shop-list-mobile.component.html',
  styleUrls: ['./pickup-shop-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TodayTomorrowDatePipe, CxDatePipe],
  standalone: false,
})
export class SdvorPickupShopListMobileComponent extends ShopListMobileComponent {
  constructor(
    modalService: ModalService,
    datePipe: TodayTomorrowDatePipe,
    shopWorkingTimeService: ShopWorkingTimeService,
    cdRef: ChangeDetectorRef,
    geocodeService: GeocodeService,
    environmentService: EnvironmentService,
    private pickupService: PickupService,
  ) {
    super(modalService, datePipe, shopWorkingTimeService, cdRef, geocodeService, environmentService);
  }

  confirmShop(id: string): void {
    super.confirmShop(id);
    this.pickupService.setShop(id);
  }
}
